module.exports = __webpack_public_path__ + "static/media/agricultural1.93d474af.jpg";